import type { IStorageService } from '@breath-lab/services';

export class WebStorageService implements IStorageService {
  constructor(private readonly backing: Storage = localStorage) {}

  get(key: string): string | null {
    return this.backing.getItem(key);
  }

  set(key: string, value: string): void {
    this.backing.setItem(key, value);
  }

  remove(key: string): void {
    this.backing.removeItem(key);
  }

  keys(prefix?: string): string[] {
    const all: string[] = [];
    for (let i = 0; i < this.backing.length; i++) {
      const key = this.backing.key(i);
      if (key && (!prefix || key.startsWith(prefix))) all.push(key);
    }
    return all;
  }
}
